import { TileFlip } from '../Utilities/TileFlip';

export class PackagesList {
  constructor() {
    TileFlip.initTileFlip('package-card');
  }
}
